import { render, staticRenderFns } from "./tab1GeneralInformation.vue?vue&type=template&id=6de284c3&scoped=true"
import script from "./tab1GeneralInformation.vue?vue&type=script&lang=js"
export * from "./tab1GeneralInformation.vue?vue&type=script&lang=js"
import style0 from "./tab1GeneralInformation.vue?vue&type=style&index=0&id=6de284c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de284c3",
  null
  
)

export default component.exports